<app-navbar></app-navbar>

<div
  style="padding: 20px;background-color: #005a63; background-size: 100px; background-attachment: fixed;"
>
  <h2 style="color:rgb(255, 255, 255); text-align: center; margin-bottom: 10px">Arts</h2>
  <br />
  
  <div style="text-align: justify !important">
    <div class="row">
      <ng-container *ngIf="News_event_data != null">
        <div class="col-md-6" *ngFor="let item of News_event_data">
          <div class="card" style="height: 100%">
            <img
              [src]="item.ShowAttachments[0].FilePath"
              class="card-img-top"
              alt="Image"
              style="height: 300px; object-fit: cover"
            />
            <div class="card-body">
              <h3>{{ item.TitleEn }}</h3>
              <p class="card-text">
                <span [innerHTML]="item.DetailsEn"></span>
              </p>
              <!-- <a [routerLink]="['/news-and-events', item.Id]" class="btn btn-primary">
                Read more
              </a> -->
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
